export default from './PriceNaming';



// WEBPACK FOOTER //
// ./src/containers/PriceNaming/index.js